module.exports = __webpack_public_path__ + "img/VAPEQUEEN-2-.c065a3fa.png";